import React, { useEffect } from 'react';
import { Container, Title, ListWrapper, List, ListItem, Item } from './styled';
import { useParams } from 'react-router-dom';
import VolleyballMatchLineupStore from './store';
import SportsTeamLogo from 'components/teamLogo';

const VolleyBallLineup = () => {
  let { id } = useParams();
  const { getLineup, data, loading } = VolleyballMatchLineupStore();

  useEffect(() => {
    getLineup(id);
  }, []);

  return (
    <Container>
      <Title>라인업</Title>
      {!loading && <ListWrapper>{data && <ListComp data={data} />}</ListWrapper>}
    </Container>
  );
};

const ListComp = ({ data }) => {
  const maxLength = Math.max(data.home.additionalTeamData.length, data.away.additionalTeamData.length);
  return (
    <List>
      {Array.from({ length: maxLength }).map((_, index) => {
        return (
          <ListItemComp
            key={index}
            home={data.home.additionalTeamData.length > index ? data.home.additionalTeamData[index] : null}
            away={data.away.additionalTeamData.length > index ? data.away.additionalTeamData[index] : null}
            data={data}
          />
        );
      })}
    </List>
  );
};
const ListItemComp = ({ home, away, data }) => {
  return (
    <ListItem>
      <Item>
        {home && (
          <>
            <div className='player-back-number'>
              {home.playerBackNumber}
            </div>
            <SportsTeamLogo
              imgSize={'24'}
              imgUrl={data.home.imgPath}
              isLazy={true}
            />
            <div className='player-name'>
              {home.playerName}
            </div>
          </>
        )}
      </Item>
      <Item>
        {away && (
          <>
            <p className='player-name'>
              {away.playerName}
            </p>
            <SportsTeamLogo
              imgSize={'24'}
              imgUrl={data.away.imgPath}
              isLazy={true}
            />
            <p className='player-back-number'>
              {away.playerBackNumber}
            </p>
          </>
        )}
      </Item>
    </ListItem>
  );
};

export default VolleyBallLineup;
